/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { Text, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import type { ComponentProps } from 'react';
import { ticketColors } from '../theme/public-api';
import { surfaceCardStyles as styles, statusPillToneStyle, type StatusPillTone } from './surfaceCards.styles';

type IconName = ComponentProps<typeof Ionicons>['name'];

type Props = {
  label: string;
  tone: StatusPillTone;
  iconName?: IconName;
  compact?: boolean;
};

export function StatusPill({ label, tone, iconName, compact = false }: Props) {
  const toneStyles = statusPillToneStyle(tone);
  const iconColor =
    tone === 'success'
      ? ticketColors.ok
      : tone === 'warning'
        ? ticketColors.gold
        : tone === 'danger'
          ? ticketColors.bad
          : ticketColors.ink2;

  return (
    <View style={[styles.statusPill, compact && styles.statusPillCompact, toneStyles.pill]}>
      {iconName ? (
        <Ionicons name={iconName} size={14} color={iconColor} style={{ flexShrink: 0 }} />
      ) : null}
      <Text style={[styles.statusPillText, toneStyles.text]} numberOfLines={1}>
        {label}
      </Text>
    </View>
  );
}

export type { StatusPillTone };
